import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { dotted, Oval } from "../../assets/imagesPath";
import { useContactFormMutation } from "../../services/Api";
import { toast } from "react-toastify";
import Loader from "../../components/loader";

const ContactUs = () => {
    const [contactForm] = useContactFormMutation();
    const [loading, setLoading] = useState(false)
    const {
        register,
        handleSubmit,
        setError,
        reset,
        formState: { errors },
    } = useForm();

    const onSubmit = (data) => {
        setLoading(true)
        contactForm({ data: data })
            .unwrap()
            .then(() => {
                toast.success("Form submitted successfully");
                reset();
                setLoading(false)
            })
            .catch((error) => {
                toast.error(error?.data?.message);
            });
    };

    const validateName = (value) => {
        if (!value.trim()) {
            return "Name is required.";
        }
        return true;
    };

    const validateEmail = (value) => {
        if (!value.trim()) {
            return "Email is required.";
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
            return "Invalid email address.";
        }
        return true;
    };

    const validateJobTitle = (value) => {
        if (!value.trim()) {
            return "Job title is required.";
        }
        return true;
    };

    const validateCompanyName = (value) => {
        if (!value.trim()) {
            return "Company name is required.";
        }
        return true;
    };

    const validatePhone = (value) => {
        if (!value.trim()) {
            return "Phone number is required.";
        }
        if (value.length < 10) {
            return "Phone number must have at least 10 characters.";
        }
        return true;
    };

    const validateMessage = (value) => {
        if (!value.trim()) {
            return "Message is required.";
        }
        return true;
    };

    return (
        <div className="w-full mb-16">
            <div className="grid grid-cols-2 smallScreens:grid-cols-1 p-16 pb-40">
                <div className="w-full flex items-center justify-center">
                    <div>
                        {/* <p className="text-[1.6rem] font-bold mb-2 text-[#818891] ml-20">Contact Us</p> */}
                        <h2 className="text-[3.6rem] font-bold mb-4 smallScreens:text-[3rem]">Get In Touch With Us</h2>
                        <p className="text-gray-600 text-[1.6rem]">
                            We’re here to assist you with any questions or concerns you may have.<br /> Whether you’re interested in our services, need more information, or simply<br /> want to chat we’re just a message away.
                            Our team is eager to provide the<br /> support and guidance you need.
                        </p>
                    </div>


                </div>
                <div className="w-[85%] smallScreens:w-full bg-white mt-20 smallScreens:mt-40 mr-6 shadow-lg rounded-lg p-10 md:p-8 relative ">
                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <input
                                    type="text"
                                    placeholder="Your Name"
                                    {...register("name", { validate: validateName })}
                                    className="text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-xl focus:outline-none w-full"
                                />
                                {errors.name && (
                                    <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
                                )}
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Job Title"
                                    {...register("jobTitle", { validate: validateJobTitle })}
                                    className="text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-xl focus:outline-none w-full"
                                />
                                {errors.jobTitle && (
                                    <p className="text-red-500 text-sm mt-1">{errors.jobTitle.message}</p>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <input
                                    type="text"
                                    placeholder="Company Name"
                                    {...register("companyName", { validate: validateCompanyName })}
                                    className="text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-xl focus:outline-none w-full"
                                />
                                {errors.companyName && (
                                    <p className="text-red-500 text-sm mt-1">
                                        {errors.companyName.message}
                                    </p>
                                )}
                            </div>
                            <div>
                                <input
                                    type="email"
                                    placeholder="Your Email"
                                    {...register("email", { validate: validateEmail })}
                                    className="text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-xl focus:outline-none w-full"
                                />
                                {errors.email && (
                                    <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                            <div>
                                <input
                                    type="text"
                                    placeholder="Your Phone"
                                    {...register("phoneNumber", { validate: validatePhone })}
                                    className="text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-xl focus:outline-none w-full"
                                />
                                {errors.phoneNumber && (
                                    <p className="text-red-500 text-sm mt-1">{errors.phoneNumber.message}</p>
                                )}
                            </div>
                        </div>
                        <div>
                            <textarea
                                rows="4"
                                placeholder="Your Message"
                                {...register("message", { validate: validateMessage })}
                                className="w-full text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-xl focus:outline-none"
                            />
                            {errors.message && (
                                <p className="text-red-500 text-sm mt-1">{errors.message.message}</p>
                            )}
                        </div>
                        <div className="text-center">
                            <button
                                type="submit"
                                className="w-full text-[1.6rem] bg-[#173363] text-white py-4 rounded-lg"
                                disabled={loading}
                            >
                                {loading ? <Loader /> : 'Send Message'}


                            </button>
                        </div>
                    </form>

                    {/* Blue Decoration */}
                    <div className="absolute -top-20 -right-20 h-[10rem] w-[10rem] z-[-1]">
                        <img src={Oval} alt="oval-img" />
                        <div className="mr-6"> <img src={dotted} alt="dotted-img" className="mt-10" /></div>
                    </div>
                    <div className="absolute -bottom-20 -left-10 h-[10rem] w-[10rem] z-[-1] mb-20">
                        <img src={dotted} alt="dotted-img" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
